<template>
  <div class="modal " @scroll.stop.prevent @touchmove.prevent v-if="schemeList.length > 0">
    <div class="content flex-column">
      <div class="flex p-30 align-center">
        <div class="flex-1">选择要加入的方案</div>
        <img src="/images/guanbi.png" alt="" @click="onClose" class="cursor">
      </div>
      <div class="hr"></div>
      <div class="flex-1 flex h-0">
        <div class="h-100 menu overflow-y">
          <div class="item flex align-center cursor" :class="menuIndex === index ? 'bg-c19357 color-ff' : 'bg-eeeff3 color-292a2e'" v-for="(item, index) in schemeList" :key="index" @click="chooseMenu(index)">{{item.name || '-'}}</div>
        </div>
        <div class="flex-1 w-0 h-100 overflow-y p-30 flex-column">
          <p class="font-12 color-292a2e mb-30">请选择<span class="color-ff5555">“{{schemeList[menuIndex].name || '-'}}”</span>的空间：</p>
          <div class="flex flex-wrap h-0 flex-1 w-100 roomList">
            <div v-for="(item, index) in schemeList[menuIndex].customerSpaceList" :key="index" class="item flex align-center justify-center" :class="[roomIndex[index] === index ? 'active' : '', index%4 === 0 ? '' : 'ml-16']" @click="chooseRoom(index)">
              {{item.name}}
            </div>
          </div>
        </div>
      </div>
      <div class="hr"></div>
      <div class="p-20 flex justify-center">
        <div class="btn-40 bg-292a2e font-16 color-ff radius-round w-153 font-yahei " @click="onSubmit">确定</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: ['currentGood'],
  data () {
    return {
      schemeList: [],
      menuIndex: 0,
      roomIndex: [],
      customerSpaceIds: []
    }
  },
  created () {},
  mounted () {
    console.log(this.currentGood)
    this.getData()
  },
  methods: {
    getData () {
      this.axios.post(`customerProgramme/list`, {}).then(res => {
        if (res.data.success) {
          this.schemeList = res.data.data
        }
      })
    },
    chooseMenu (index) {
      this.menuIndex = index
      this.roomIndex = []
    },
    chooseRoom (index) {
      console.log(index)
      if (this.roomIndex.length>0) {
         for (let i=0;i<this.roomIndex.length;i++) {
          if (this.roomIndex[i] == index) {
            this.roomIndex.splice(i,1)
            return
          }
        }
        this.$set(this.roomIndex,index,index)
      } else {
        this.$set(this.roomIndex,index,index)
      }
    },
    onSubmit () {
      let myCase = []
      if (this.roomIndex.length>0) {
        for (let i=0;i<this.roomIndex.length;i++) {
           this.currentGood.customerSpaceId =  this.schemeList[this.menuIndex].customerSpaceList[this.roomIndex[i]].id
           for (let m=0;m<this.currentGood.customerSpaceAttributeParamList.length;m++) {
             this.currentGood.customerSpaceAttributeParamList[m].customerSpaceGoodsId = this.schemeList[this.menuIndex].customerSpaceList[this.roomIndex[i]].id
           }
           myCase.push(this.currentGood)
        }
        this.$emit('submit',myCase)
      } else {
        this.$message({
          message: '请选择要加入方案的空间',
          type: 'warning'
        })
      }
    },
    onClose () {
      this.$parent.isChooseScheme = false
    },
  }
};
</script>

<style lang="scss" scoped>
  .modal{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
      width: 1105px;
      height: 640px;
      background: #ffffff;
      border-radius: 4px;
    }
  }
  .menu{
    border-right: 1px solid #e9e9e9;
    width: 245px;
    padding: 30px;
    .item {
      font-size: 16px;
      height: 73px;
      border-radius: 4px;
      padding: 0 20px;
      margin-bottom: 15px;
    }
  }
  .roomList{
    .item{
      width: 185px;
      height: 73px;
      border-radius: 4px;
      border: solid 1px #e9e9e9;
      font-size: 14px;
      cursor: pointer;
      color: #292a2e;
      margin-bottom: 16px;
    }
    .active{
      color: #c19357;
      border-color: #c19357;
      background: #f3e9dd;
    }
  }
  .w-153 {
    width: 153px;
  }
</style>
